import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bool, node } from 'prop-types';


const Drawer = ({ isExpanded, children }) => (
  <nav
    className={classnames(
      'app-drawer',
      'mdc-drawer',
      'mdc-drawer--permanent',
      { collapsed: !isExpanded },
    )}
  >
    <nav className="mdc-list">
      {children}
    </nav>
  </nav>
);

Drawer.propTypes = {
  isExpanded: bool.isRequired,
  children: node.isRequired,
};

export default connect(
  ({ drawer, found: { resolvedMatch } }) => ({
    location: resolvedMatch.location,
    params: resolvedMatch.params,
    isExpanded: drawer.expanded,
  }),
)(Drawer);
